import { Button, message, Table } from 'antd';
import { calculateColumnsWidth } from 'api/common';
import { LoadingScreen } from 'common/components';
import { createContext, useEffect, useState, useCallback } from 'react';
import FilterColumns from './FilterColumn';
import moment from 'moment';
import xlsx from 'json-as-xlsx';

import {
  PresentmentDashboard,
  presentmentDashboardAutopayFalseFilter,
  presentmentDashboardRedmption,
  PresentmentFilterPaylaod,
  PresentmentPagedList,
} from 'api/nach';
import { usePresentmentFilterContext } from 'features/nach/presentment/context/PresenmentFilterProvider';
import { useAutoPayFalseTabsContext } from '..';
import Loading from 'features/nach/components/Loading';

export const ReloadFilterListContext = createContext<any>(null);

function getFullDate(date: string) {
  if (date != null) {
    let dateMoment = moment(new Date(date)).format('YYYY/DD/MM HH:mm:ss');
    return dateMoment;
  }
}
// Initial state for the paginated list
const initialPresentmentPagedList: PresentmentPagedList = {
  currentPageIndex: 1, // Or 0, depending on your API's first page index
  noOfRecords: 0,
  data: [],
};
function ProcessFilterList() {
  const [presentmentIds, setPresentmentIds] = useState<number[]>([]);
  const { filter, setFilter, currentActiveTabKey } = usePresentmentFilterContext();
  const { reload, setReload, autopayFalseCurrentTab } = useAutoPayFalseTabsContext();
  //const [pagedList, setPagedList] = useState<PresentmentDashboard[]>([]);
  const [pagedList, setPagedList] = useState<PresentmentPagedList>(initialPresentmentPagedList); // Use PresentmentPagedList

  const [isLoading, setIsLoading] = useState(false);
  const [isRetry, setIsRetry] = useState(false);
  const [isRedemtionCall, setIsRedemtionCall] = useState(false);
  // Local state for pagination parameters
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // Default page size
  const [fetchedDate, setFetchedDate] = useState('');
  //const [tableKey, setTableKey] = useState(0);
  const [deselectedAll, setDeselectedAll] = useState(false);

  useEffect(() => {
    console.log("-auto pay false process filters currecnt tab:", autopayFalseCurrentTab)

    if (!filter || !filter.startDate || !filter.endDate) {
      setIsLoading(true);
      setPagedList(initialPresentmentPagedList);
      // message.warn('Please select date');
      return;
    }

    if (filter?.isExtract && autopayFalseCurrentTab == '3process' && (currentActiveTabKey != 2 && currentActiveTabKey != 3 && currentActiveTabKey != 5)) {
      console.log("---DOWNLOAD TRIGGERED for auto Pay false Process---", filter);
      handleDownloadData();
      return
    }
    setIsLoading(true);

    //setPagedList([]);
    const filterForTableFetch = { ...filter };
    delete filterForTableFetch.isExtract;
    delete filterForTableFetch.pageNo;
    delete filterForTableFetch.pageSize;
    const filterForTableFetchString = JSON.stringify(filterForTableFetch);
    if ((fetchedDate != filterForTableFetchString && autopayFalseCurrentTab == '3process') || isRetry || reload) {
      setFetchedDate(filterForTableFetchString);
      setPagedList(initialPresentmentPagedList);

      // let pageToFetch = currentPage;
      // let sizeToFetch = pageSize;

      // // Reset to page 1 and default size if reload or isRetry is triggered
      // if (reload || isRetry) {
      //   pageToFetch = 1;
      //   sizeToFetch = 10;
      //   setCurrentPage(1); // Update local state
      //   setPageSize(10); // Update local state
      // }

      const newFilter: PresentmentFilterPaylaod = {
        ...filter,
        presentmentFlagId: 3,
        autopayFlaseFilterMsg: 'PENDING_FOR_REDEMPTION',
        pageNo: 1, // Pass current page
        pageSize: pageSize, // Pass current page size
      };
      presentmentDashboardAutopayFalseFilter(newFilter)
        .then((res) => {
          console.log('presentment response data ', res);
          if (res.data) {
            setPagedList(res.data);
          }
        })
        .finally(() => {
          setIsLoading(true);
          setReload(false); // Reset reload state after the fetch is complete
          setIsRetry(false); // Reset retry state
        });
    }
  }, [isRetry, filter, reload, currentPage, pageSize, fetchedDate]);

  const handleDownloadData = useCallback(() => {
    const downloadPayload: PresentmentFilterPaylaod = {
      ...filter,
      presentmentFlagId: 3, // Assuming this is the correct flag for this list
      autopayFlaseFilterMsg: 'PENDING_FOR_REDEMPTION',
      isExtract: true, // Confirming extraction
      pageNo: 1, // Or a value your backend understands as "all pages"
      pageSize: pageSize, // Or a value your backend understands as "all items"
    };

    presentmentDashboardAutopayFalseFilter(downloadPayload)
      .then((res) => {
        console.log('Download data fetched', res);
        if (res.data && res.data.data.length > 0) { // Ensure res.data and res.data.data exist
          performExcelDownload(res.data.data); // Pass the actual data array
        } else {
          message.destroy();
          message.error('No data found for download in Auto pay False-Process');
        }
      })
      .catch((error) => {
        console.error('Error fetching data for download:', error);
        message.error('Failed to download data.');
      })
      .finally(() => {
        //setIsLoading(true); // Hide loading after download attempt
        //const resetFilter = { ...filter, isExtract: false };
        //setFilter(resetFilter);
        //message.destroy(); // Hide loading message
        setFilter((prevFilter: PresentmentFilterPaylaod) => ({
          ...prevFilter,
          isExtract: false,
        }));
      });

  }, [filter, setFilter]);
  const performExcelDownload = (dataToDownload: PresentmentDashboard[]) => {
    let settings = {
      fileName: 'presentment_Auto_false_Process',
      extraLength: 3,
      writeMode: 'writeFile',
      writeOptions: {},
      RTL: false,
    };

    const updatedData = dataToDownload.map((item: any, index) => ({
      ...item,
      NOTIFICATIONDATE: getFullDate(item.notificationDate),
      DATEOFTXN: getFullDate(item.dateOfTxn),
      CREATEDON: getFullDate(item.createdOn),
      ROWNUM: index + 1, // Add the row number (index + 1 to start from 1)
    }));

    let data = [
      {
        sheet: 'Sheet 1',
        columns: [
          { label: 'ROWNUM', value: 'ROWNUM' },
          { label: 'UMRN NO', value: 'umrnNO' },
          { label: 'Corporate Name', value: 'corporateName' },
          { label: 'Corporate User No', value: 'corporateUserNo' },
          { label: 'Amount', value: 'amount' },
          { label: 'Transaction ID REF', value: 'transactionIDREF' },
          { label: 'Unique Reference', value: 'uniqueReference' },
          { label: 'Batch No', value: 'batchNo' },
          { label: 'Created On', value: 'CREATEDON' },
          { label: 'Customer Debit AC', value: 'customerDebitAC' },
          { label: 'Customer MICR', value: 'customerMICR' },
          { label: 'Date Of Transaction', value: 'DATEOFTXN' },
          { label: 'Debitor Name', value: 'debtorName' },
          { label: 'IFSC', value: 'ifsc' },
          { label: 'Loan Type', value: 'loanType' },
          { label: 'Merchant Order Id', value: 'merchantOrderId' },
          { label: 'Merchant Subscription Id', value: 'merchantSubscriptionId' },
          { label: 'Notification Date', value: 'NOTIFICATIONDATE' },
          { label: 'Notify Response Order ID', value: 'notifyResponseOrderID' },
          { label: 'Partner Bank', value: 'partnerBank' },
          { label: 'Pre Notification Status', value: 'preNotificationStatus' },
          { label: 'Presentment Flag', value: 'presentmentFlag' },
          { label: 'Presentment Id', value: 'presentmentId' },
          { label: 'Presentment Status', value: 'presentmentStatus' },
          { label: 'Sourcing Type', value: 'sourcingType' },
          { label: 'Created By', value: 'userName' },
        ],
        content: updatedData,
      },
    ];
    xlsx(data, settings);
  };
  if (!pagedList || !isLoading) {
    return <LoadingScreen />;
  }

  const handleChange = (_pagination: any, _filters: any, sorter: any) => {
    if (sorter.hasOwnProperty('column')) {
      // params.order = { field: sorter.field, dir: sorter.order };
    }
    setIsLoading(false);
    setCurrentPage(_pagination.current);
    setPageSize(_pagination.pageSize);
    // filter.Username = sessionStorage.getItem('user')?.toString();
    // if (isAdmin != 'true') {
    // filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
    // }

    // filter.PageNo = _pagination.current;
    // filter.PageSize = _pagination.pageSize;
    const newFilter: PresentmentFilterPaylaod = {
      ...filter,
      presentmentFlagId: 3,
      autopayFlaseFilterMsg: 'PENDING_FOR_REDEMPTION',
      pageNo: _pagination.current,
      pageSize: _pagination.pageSize,
    };
    presentmentDashboardAutopayFalseFilter(newFilter)
      .then((res) => {
        if (res.data) {
          setPagedList(res.data);
        }
      })
      .finally(() => {
        setIsLoading(true);
      });
  };

  const maxWidthPerCell = 600;

  const dataTable = calculateColumnsWidth(FilterColumns, pagedList.data || [], maxWidthPerCell);
  const tableHeight = 500;
  //const rowKey = 'ROWNUM';
  //const rowKey = 'presentmentId';

  const handleRedemtion = () => {
    if (presentmentIds.length == 0) {
      message.destroy();
      message.warning('Please select some data');
      return;
    }
    setIsRedemtionCall(true);

    presentmentDashboardRedmption({ listOfIds: presentmentIds })
      .then((res) => {
        message.destroy();
        if (res.status == 'SUCCESS') {
          message.success('Successfully called redemption');
          setPresentmentIds([]);
          setReload(true);
        }
      })
      .then(() => {
        setTimeout(() => {
          setReload((prev: boolean) => !prev);
        });
      })
      .finally(() => {
        setIsRedemtionCall(false);
      });
  };

  // const onChangeSelectedKey = (selectedRowKeys: any) => {
  //   setPresentmentIds([...selectedRowKeys]);
  // };

  const handleSelectAll = (selected: boolean) => {
    // Let's implement a simplified version that fetches all IDs if `isExtract` is used.
    if (selected) {
      // message.loading('Fetching all records for selection...', 0);
      const downloadPayload: PresentmentFilterPaylaod = {
        ...filter,
        presentmentFlagId: 3,
        autopayFlaseFilterMsg: 'PENDING_FOR_REDEMPTION',
        isExtract: true,
        pageNo: 1,
        pageSize: 10000000, // A large number or a special value for "all"
      };

      presentmentDashboardAutopayFalseFilter(downloadPayload)
        .then((res) => {
          if (res.data && res.data.data.length > 0) {
            const allIds = res.data.data.map((item: any) => item.presentmentId);
            setPresentmentIds(allIds);
            //message.success(`${allIds.length} records selected.`);
          } else {
            message.error('No data found to select.');
          }
        })
        .catch(() => {
          message.error('Failed to fetch all data for selection.');
        })
        .finally(() => {
          message.destroy();
        });
      setDeselectedAll(false);
    } else {

      setPresentmentIds([]);
      //setReload((prev: boolean) => !prev);// Trigger a re-render to clear all checkboxes
      //setTableKey(prev => prev + 1); // Incrementing the key forces a full re-render
      setDeselectedAll(true);
      // message.success('All records deselected.');
    }
  };


  const onChangeSelectedKey = (selectedRowKeys: any) => {
    setPresentmentIds(selectedRowKeys);
    if (deselectedAll && selectedRowKeys.length > 0) {
      setDeselectedAll(false); // Reset the flag once a new selection is made
    }
  };

  return (
    <ReloadFilterListContext.Provider value={{ setIsRetry, isRetry }}>
      <Loading isLoading={isRedemtionCall} />
      <div style={{ textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            onClick={handleRedemtion}
            type="primary"
            htmlType="submit"
            style={{
              float: 'right',
              marginRight: '30px',
              backgroundColor: 'rgb(44, 152, 151)',
              border: 'none',
            }}
          >
            Proceed Redemption
          </Button>
        </div>
      </div>
      <Table
        //key={tableKey} // This is the fix for the deselection issue
        rowSelection={{
          type: 'checkbox',
          selectedRowKeys: deselectedAll ? [] : presentmentIds,
          //selectedRowKeys: [...presentmentIds],
          //onSelect: (record) => onSelectRows(record),
          onSelectAll: handleSelectAll,
          // onSelectAll:
          // hideSelectAll: true,
          // columnTitle: 'Select All',
          onChange: onChangeSelectedKey,

          columnWidth: '50px',
          fixed: 'left',
        }}
        dataSource={dataTable.source}
        columns={dataTable.columns}
        rowKey={(record) => record.presentmentId}
        //rowKey={rowKey}
        //pagination={false}
        // pagination={{
        //   pageSize: 10,
        //   total: pagedList.noOfRecords - 10,
        //   current: pagedList.currentPageIndex == 0 ? 1 : pagedList.currentPageIndex,
        // }}
        pagination={{
          pageSize: pageSize, // Use the state variable
          total: pagedList.noOfRecords, // Total records from your API response
          current: pagedList.currentPageIndex === 0 ? 1 : pagedList.currentPageIndex, // Current page from API
          showSizeChanger: true, // Allow changing page size
          pageSizeOptions: ['10', '20', '50', '100'], // Options for page size
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`, // Optional: show total items
        }}
        scroll={{ x: dataTable.tableWidth, y: tableHeight }}
        onChange={handleChange}
      />
    </ReloadFilterListContext.Provider>
  );
}

export default ProcessFilterList;
